<template>
  <div class="app-container">
    <!-- Header / Navbar -->
    <header class="header shadow-md animate__animated animate__fadeInDown">
      <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
          <!-- Brand -->
          <router-link to="/dashboard" class="navbar-brand">
            <img :src="logo" alt="PACMIS Logo" class="brand-image" />
            <span class="brand-text">PACMIS Plantation</span>
          </router-link>

          <!-- Mobile Toggler -->
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapse"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <!-- Navigation -->
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item">
                <router-link to="/dashboard" class="nav-button">
                  <i class="fas fa-home"></i> Home
                </router-link>
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle dropdown-button"
                  href="#"
                  data-toggle="dropdown"
                >
                  Plantation
                </a>
                <ul class="dropdown-menu">
                  <li>
                    <router-link to="/units" class="dropdown-item gradient-link">
                      <i class="fas fa-industry"></i> Units
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/harvests"
                      class="dropdown-item gradient-link"
                    >
                      <i class="fas fa-seedling"></i> Harvests
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/workers"
                      class="dropdown-item gradient-link"
                    >
                      <i class="fas fa-users"></i> Workers
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/shipments"
                      class="dropdown-item gradient-link"
                    >
                      <i class="fas fa-truck"></i> Shipments
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/tasks"
                      class="dropdown-item gradient-link"
                    >
                      <i class="fas fa-tasks"></i> Tasks
                    </router-link>
                  </li>
                </ul>
              </li>

              <li class="nav-item">
                <router-link to="/marketplace" class="nav-button">
                  <i class="fas fa-store"></i> Market
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/contact" class="nav-button">
                  <i class="fas fa-envelope"></i> Contact
                </router-link>
              </li>
            </ul>

            <!-- Search -->
            <form class="search-form">
              <div class="input-group">
                <input
                  class="form-control"
                  type="search"
                  placeholder="Search plantations, workers, units..."
                />
                <div class="input-group-append">
                  <button class="btn btn-search" type="submit">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </form>

            <!-- Notifications and Account -->
            <ul class="navbar-nav ml-auto align-items-center">
              <li class="nav-item dropdown">
                <a class="nav-link" data-toggle="dropdown" href="#">
                  <i class="far fa-bell"></i>
                  <span class="badge badge-warning">3</span>
                </a>
                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                  <span class="dropdown-header">3 Notifications</span>
                  <div class="dropdown-divider"></div>
                  <a href="#" class="dropdown-item">
                    <i class="fas fa-tractor mr-2"></i> New harvest recorded
                  </a>
                  <div class="dropdown-divider"></div>
                  <a href="#" class="dropdown-item">
                    <i class="fas fa-user-plus mr-2"></i> New worker added
                  </a>
                  <div class="dropdown-divider"></div>
                  <a href="#" class="dropdown-item dropdown-footer"
                    >See all notifications</a
                  >
                </div>
              </li>

              <li class="nav-item dropdown ml-2">
                <a
                  class="nav-link dropdown-toggle account-link"
                  href="#"
                  data-toggle="dropdown"
                >
                  <i class="fas fa-user-circle"></i> Account
                </a>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li>
                    <router-link to="/profile" class="dropdown-item"
                      >Profile</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/settings" class="dropdown-item"
                      >Settings</router-link
                    >
                  </li>
                  <li>
                    <button @click="logout" class="dropdown-item text-danger">
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>

    <!-- Main Content -->
    <main class="main-content animate__animated animate__fadeIn">
      <router-view></router-view>
    </main>

    <!-- Footer -->
    <footer class="footer shadow-sm animate__animated animate__fadeInUp">
      <div class="footer-content">
        <div>&copy; 2025 PACMIS Plantation — All Rights Reserved</div>
        <div class="footer-links">
          <router-link to="/contact">Contact</router-link> |
          <router-link to="/privacy">Privacy</router-link>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "PlantationLayout",
  data() {
    return {
      logo: "/img/pacmislogo.png",
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
  },
  mounted() {
    if (this.$resetIdleTimer) this.$resetIdleTimer();
  },
};
</script>

<style scoped>
.app-container {
  width: 100%;
  background: linear-gradient(120deg, #f4f6f9, #e0eafc);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header Navbar */
.header {
  background: linear-gradient(135deg, #43e97b, #38f9d7);
  backdrop-filter: blur(10px);
  color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.navbar {
  padding: 10px 20px;
}

.brand-image {
  width: 60px;
  height: auto;
  margin-right: 10px;
}
.brand-text {
  font-size: 1.3rem;
  font-weight: bold;
  color: white;
  letter-spacing: 1px;
}

.nav-button {
  display: inline-flex;
  align-items: center;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
  background: linear-gradient(45deg, #6a11cb, #2575fc);
}
.nav-button:hover {
  background: linear-gradient(45deg, #2575fc, #6a11cb);
  transform: scale(1.05);
}

/* Dropdown */
.dropdown-menu {
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  border: none;
  overflow: hidden;
}
.gradient-link {
  background: linear-gradient(135deg, #e0eafc, #cfdef3);
  transition: all 0.3s ease;
  color: #333;
}
.gradient-link:hover {
  background: linear-gradient(135deg, #6a82fb, #fc5c7d);
  color: white;
  transform: translateX(6px);
}

/* Search */
.search-form .form-control {
  border-radius: 8px 0 0 8px;
  padding: 6px 12px;
}
.btn-search {
  background: linear-gradient(135deg, #ff5e57, #ff9966);
  color: white;
  border-radius: 0 8px 8px 0;
  transition: all 0.3s ease;
}
.btn-search:hover {
  transform: scale(1.05);
}

/* Account Dropdown */
.account-link {
  color: white;
  font-weight: 600;
  transition: color 0.3s ease;
}
.account-link:hover {
  color: #ffeb3b;
}

/* Footer */
.footer {
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  color: white;
  padding: 15px 0;
  text-align: center;
  margin-top: auto;
}
.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer-links a {
  color: #ffeb3b;
  margin: 0 5px;
  text-decoration: none;
  transition: color 0.3s ease;
}
.footer-links a:hover {
  color: white;
}

/* Animations */
.animate__animated {
  animation-duration: 0.8s;
}
</style>
